import { applyOpts } from './apply.js';
import { applyStrokeOpts } from './stroke.js';
import { remove } from './remove.js';
import * as Elements from './elements.js';
/**
 * Creates a {@link SvgHelper} for the creating and management of SVG elements.
 * @param parent
 * @param parentOpts
 * @returns
 */
export const makeHelper = (parent, parentOpts) => {
    if (parentOpts) {
        applyOpts(parent, parentOpts);
        applyStrokeOpts(parent, parentOpts);
    }
    const o = {
        remove: (queryOrExisting) => { remove(parent, queryOrExisting); },
        text: (text, pos, opts, queryOrExisting) => Elements.text(text, parent, pos, opts, queryOrExisting),
        textPath: (pathReference, text, opts, textQueryOrExisting, pathQueryOrExisting) => Elements.textPath(pathReference, text, parent, opts, textQueryOrExisting, pathQueryOrExisting),
        line: (line, opts, queryOrExisting) => Elements.line(line, parent, opts, queryOrExisting),
        circle: (circle, opts, queryOrExisting) => Elements.circle(circle, parent, opts, queryOrExisting),
        path: (svgString, opts, queryOrExisting) => Elements.path(svgString, parent, opts, queryOrExisting),
        grid: (center, spacing, width, height, opts) => Elements.grid(parent, center, spacing, width, height, opts),
        query: (selectors) => parent.querySelector(selectors),
        get width() {
            const w = parent.getAttributeNS(null, `width`);
            if (w === null)
                return 0;
            return Number.parseFloat(w);
        },
        set width(width) {
            parent.setAttributeNS(null, `width`, width.toString());
        },
        get parent() {
            return parent;
        },
        get height() {
            const w = parent.getAttributeNS(null, `height`);
            if (w === null)
                return 0;
            return Number.parseFloat(w);
        },
        set height(height) {
            parent.setAttributeNS(null, `height`, height.toString());
        },
        clear: () => {
            while (parent.firstChild) {
                parent.lastChild.remove();
            }
        },
    };
    return o;
};
